export default {"src":"/_next/static/media/user-flash-circle.4d8371f1.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};